import { render, staticRenderFns } from "./Funnel.vue?vue&type=template&id=97663116&"
import script from "./Funnel.vue?vue&type=script&lang=js&"
export * from "./Funnel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports